import { render } from "./waitinglisttype.vue?vue&type=template&id=a9901fe4"
import script from "./waitinglisttype.vue?vue&type=script&lang=js"
export * from "./waitinglisttype.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__